import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import _ from 'lodash';
import Utility from '../../util/utilityfunctions';

/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      store.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export default function canvasFormUpdateFiltersReducer(state = initialState.canvasFormUpdateFilters, action) {
	switch (action.type) {
		case types.SET_CANVAS_FORM_UPDATE_MENU_FILTERS: {
			let filters = {...state};

			Object.entries(action.filters).forEach((level) => {
				filters[action.filterKey] = {
					...filters[level[0]],
					...level[1]
				};
			});

			return filters;
		}

		case types.SET_CANVAS_FORM_UPDATE_MENU_FILTER: {
			let value = action.value;
			if (!Utility.hasValue(value)) {
				// If filter is being disabled, explicit undefined is required
				value = null;
			}

			let filters;
			filters = {...state};
			if (action.filterKey) {
				if (filters[action.filterKey]) {
					filters[action.filterKey] = {...filters[action.filterKey]};
				} else {
					filters[action.filterKey] = {};
				}

				filters[action.filterKey][action.filterItemName] = value;

				if (!Utility.hasValue(filters[action.filterKey][action.filterItemName])) {
					delete filters[action.filterKey][action.filterItemName];
				}
			} else {
				filters[action.filterItemName] = value;
			}

			return {
				...state,
				...filters
			};
		}

		case types.CLEAR_CANVAS_FORM_UPDATE_MENU_FILTERS: {
			let filters = {...state};
			filters[action.filterKey] = {};
			return filters;
		}
		case types.SET_CANVAS_FORM_UPDATE_FILTERS: {
			let taskListFilters = action.filters;
			if (action.filterType) {
				let newFilter = [];
				if (taskListFilters[action.filterType]) {
					newFilter = _.cloneDeep(taskListFilters[action.filterType]);
					newFilter.push(action.filterValue);
				} else {
					newFilter.push(action.filterValue);
				}
				taskListFilters[action.filterType] = newFilter;
			}
			return {...state, ...taskListFilters, quickFilterId: action.quickFilterId};
		}

		case types.RESET_TASK_CATEGORY: {
			let taskListFilters = action.filters;
			if (action.filterType) {
				let newFilter = [];
				if (taskListFilters[action.filterType]) {
					newFilter = _.cloneDeep(taskListFilters[action.filterType]);
					newFilter.push(action.filterValue);
				} else {
					newFilter.push(action.filterValue);
				}
				taskListFilters[action.filterType] = newFilter;
			}
			return {...state, ...taskListFilters};
		}
		case types.RESET_CANVAS_FORM_UPDATE_FILTERS: {
			let taskListFilters = action.filters;
			if (action.filterType) {
				let newFilter = [];
				if (taskListFilters[action.filterType]) {
					newFilter = _.cloneDeep(taskListFilters[action.filterType]);
					newFilter.push(action.filterValue);
				} else {
					newFilter.push(action.filterValue);
				}
				taskListFilters[action.filterType] = newFilter;
			}
			return {...initialState.canvasFormUpdateFilters, ...taskListFilters};
		}
		case types.CLEAR_CANVAS_FORM_UPDATE_FILTERS: {
			if (action.data) {
				return Object.assign({}, initialState.canvasFormUpdateFilters, action.data);
			}
			return initialState.canvasFormUpdateFilters;
		}
		default:
			return state;
	}
}
